import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const subscriptionsForDeletedUsers: boolean = isFeature('subscriptions-for-deleted-users') || false;
